import React from "react";
import { find } from "lodash";
import { useForm } from "antd/es/form/Form";
import { Col, Form, Input, Row, Select, Button, Upload, message, Spin } from "antd";
import { reportMappings } from "../../constants/reportMappings";
import { SectionHeader } from "../../components/SectionHeader/SectionHeader";
import css from "../Dashboard/Dashboard.module.css"; 

export const Mapper = ({ headers, onSubmit, loading }) => {
	const [mapForm] = useForm();
	const requiredRule = [{
	  required: true,
	  message: "This field is required",
	}];
	
	const headerOptions=headers.sort().map(header=>({
		label: header,
		value: header
	}))
	const initialValues = {};
	for(let header of headers) {
		initialValues[header] = header;
	}
		
  return (
	
	<div className={"ibox-holder"}>
		<SectionHeader title="Header Mapping" />
	  <Form
		form={mapForm}
		name="fieldMapperForm"
		autoComplete="off"
		layout="vertical"
		onFinish={onSubmit}
		initialValues={{fields: {...initialValues}}}
	  >
	  <Form.List name="fields">
	  {(fields, { add, remove }, { errors }) => (
		  <>
		{reportMappings.map(field => {
			return <Row gutter={16} key={field.value} >
				<Col xs={24} md={8}>
				<Form.Item
					name={field.value}
					value={field.value}
					className={css.reportFormItem}
					label={<span className={css.label}>{field.label}</span>}
					rules={field.required?requiredRule:[]}
					defaultValue={field.value}
				>
					<Select
						allowClear
						placeholder={field.label}
						size="large"
						options={headerOptions}
						defaultValue={field.value}
					/>
				</Form.Item>
				</Col>
			</Row>
			
		})}
	    </>
	)}
	  </Form.List>
		<Row gutter={16}>
			<Col xs={24} md={24} lg={12} xl={6}>
				<Row gutter={8}>
				<Col xs={12} md={8} lg={12} xl={12}>
					<Form.Item className={css.buttonsHolder}>
						<Button
							type="primary"
							size="large"
							rootClassName={css.submitButton}
							onClick={()=>mapForm.submit()}
						>
							Apply
						</Button>
						{loading && <Spin size="small" />}
					</Form.Item>
				</Col>
				</Row>
			</Col>
		</Row>
  	  </Form>
	</div>
  );
};
